/* eslint-disable no-prototype-builtins */
/* eslint-disable max-lines */
/* eslint-disable no-shadow */
import { call, takeEvery } from "redux-saga/effects";
import { getId, injectApiWithContextFactory, injectBoundActionCreatorsFactory } from "Utils/sagaUtils";
import noop from "lodash.noop";
import { chainInstanceActionResult, defaultChainInstance, loadChainInstance, upsertChainInstance } from "./userPrompt.api";
import { injectBoundGQLClient } from "Utils/injectBoundGQLClient";
import { v4 as uuidv4 } from "uuid";
import {
  USER_PROMPT_LOAD_REQUESTED,
  USER_PROMPT_SAVE_REQUESTED,
  // USER_PROMPT_SAVE_REQUESTED,
  defaultScopeId,
  loadFail,
  loadSuccess,
  saveFail,
  saveSuccess,
} from "./userPrompt.duck";

export const withBoundActions = injectBoundActionCreatorsFactory(
  {
    loadFail,
    loadSuccess,
    saveFail,
    saveSuccess,
  },
  () => defaultScopeId
);

export const withApiContext = injectApiWithContextFactory(
  {
    chainInstanceActionResult,
    loadChainInstance,
    upsertChainInstance,
  },
  injectBoundGQLClient
);

function* loadChainInstanceSaga({ api: { loadChainInstance = noop, upsertChainInstance = noop }, actions: { loadSuccess, loadFail }, resolve = noop, reject = noop }) {
  try {
    let result = yield loadChainInstance();

    if (result === null || !result) {
      const { chain } = defaultChainInstance();
      result = yield upsertChainInstance({ chain: chain() });
    }
    yield loadSuccess(result);
    yield call(resolve);
  } catch (error) {
    yield loadFail(error);
    yield call(reject, error);
  }
}

function* upsertChainInstanceSaga({
  data: { chain },
  api: { upsertChainInstance = noop, chainInstanceActionResult = noop },
  actions: { saveSuccess, saveFail },
  resolve = noop,
  reject = noop,
  mdContext = {},
}) {
  try {
    const ensureIdInChain = chain.map(obj => {
      return obj.hasOwnProperty("id") ? obj : { ...obj, id: uuidv4() };
    });

    const result = yield upsertChainInstance({ chain: ensureIdInChain });

    yield saveSuccess(result);
    yield chainInstanceActionResult({ actionResult: { event: "chainInstancesModified", projectId: mdContext.project, success: true } });
    yield call(resolve);
  } catch (error) {
    yield saveFail(error);
    yield chainInstanceActionResult({ actionResult: { success: false, message: error } });
    yield call(reject, error);
  }
}

export default () =>
  function* rootSaga() {
    yield takeEvery(USER_PROMPT_LOAD_REQUESTED, withApiContext(withBoundActions(loadChainInstanceSaga)));
    yield takeEvery(USER_PROMPT_SAVE_REQUESTED, withApiContext(withBoundActions(upsertChainInstanceSaga)));
  };
